<div class="screen screen--gate">

  <div class="gate__body">
    <span class="gate__icon"><i class="icon icon--compass"></i></span>

    <p class="belturo-eyebrow"><%= _lcs( 'Seite nicht gefunden' ) %></p>
    <h1 class="gate__title"><%= _lcs( 'Diese Seite gibt es nicht' ) %></h1>
    <p class="gate__text"><%= _lcs( 'Der Link ist veraltet oder unvollständig. Auf der Startseite findest du alles rund um deinen Aufenthalt.' ) %></p>

    <div class="gate__actions">
      <button class="btn btn--primary btn--lg btn--block" type="button" data-id="home"><%= _lcs( 'Zur Startseite' ) %></button>
    </div>
  </div>

</div>
